//"https://rubiksoftwares.com/hrsoft/public";
//http://localhost/hr-app-api/public/
//https://rm.plant-supervision.com
export const _BASE_URL="https://rm.plant-supervision.com";
//export const _BASE_URL = 'https://rubiksoftwares.com/hrsoft/public';
export const _LOGIN_URL = `${_BASE_URL}/auth/login`;
export const _OTP_URL = `${_BASE_URL}/auth/validateOTP`;
export const _FORGOT_PASS_URL = `${_BASE_URL}/auth/forgot-pass`;
export const _SETTINGS_PATH = `${_BASE_URL}/SettingsController`;
export const _USER_PATH = `${_BASE_URL}/UserController`;
export const _TRIP_PATH = `${_BASE_URL}/TripController`;

const HR_BASE = `${_BASE_URL}/hr`;

export const HrRoutes = {
  // Resumes
  resumesList: `${HR_BASE}/get-resumes`,
  filterResume: `${HR_BASE}/filter-resume`,
  filterConfig: `${HR_BASE}/get-filter-config`,
  getResume: (id) => `${HR_BASE}/get-resume/${id}`,
  deleteResume: (id) => `${HR_BASE}/deleteResume/${id}`,
  uploadResume: `${HR_BASE}/upload-resume`,
  addResume: `${HR_BASE}/add-resume`,
  addResumeOld: `${HR_BASE}/add-resume-old`,
  checkDuplicateResume: `${HR_BASE}/check-duplicate-resume`,

  // Comments
  addComment: `${HR_BASE}/add-comment`,

  // Search
  searchList: (id) => `${HR_BASE}/get-searchList/${id}`,
  addSearch: `${HR_BASE}/add-search`,
  deleteSearch: `${HR_BASE}/delete-search`,

  // Email
  sendEmail: `${HR_BASE}/send-email`,

  // Images & Files
  getImage: (filename) => `${HR_BASE}/get-pic/${filename}`,
  downloadDoc: `${HR_BASE}/download-doc`,
  resumePdf: (id) => `${HR_BASE}/response-pdf/${id}`,
  uploadPhoto: `${HR_BASE}/upload-photo`,

  // Filters
  updateTripFilter: `${HR_BASE}/update-trip-filter`,
  getUserFilter: `${HR_BASE}/get-user-filter`,

  // Hangaround
  hangaroundList: `${HR_BASE}/hangaround`,
  hangaroundOld: `${HR_BASE}/hangaround-old`,
  hangaroundEmp: (id) => `${HR_BASE}/hangaround-emp/${id}`,

  // Misc
  hangaroundPing: `${HR_BASE}/hangaround`,
  fetchKnownMem: `${HR_BASE}/fetch-known-mem`,
};

export const _PERMISSIONS = [
  {
    label: 'Project',
    value: 'project',
  },
  {
    label: 'Client',
    value: 'client',
  },
  {
    label: 'Trip',
    value: 'trip',
  },
  {
    label: 'HR',
    value: 'hr',
  },
  {
    label: 'Terms and Condition',
    value: 'termsCondition',
  },
];
export const _APPROVERS = [
  {
    label: 'Main',
    value: '1',
  },
  {
    label: 'Secondary',
    value: '2',
  },
];
